import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VolatilityAlert } from '../../types/entities';

import { initialState, VolatilityAlertState } from './state';

const volatilityProfileSlice = createSlice({
  name: 'volatility-alert',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: VolatilityAlertState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    pending: (state: VolatilityAlertState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.pending = action.payload;
    },
    success: (state: VolatilityAlertState, action: PayloadAction<VolatilityAlert[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.pending = false;
      state.alerts = action.payload;
    },
    fail: (state: VolatilityAlertState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.pending = false;
      state.alerts = [];
    }
  }
});

const { actions, reducer } = volatilityProfileSlice;
export const { reset, loading, success, fail, pending } = actions;
export default reducer;
